import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React from 'react';

import { Checkbox } from '@material-ui/core';

import { Control, LocalForm } from 'react-redux-form';

import Alert from '../../container/Alert';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import replaceID from '../../../utility/replaceID';
import steps from '../../../data/assesment-steps';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'assessment.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Free Assessment'
  },
  headerSubTitle: {
    id: 'assessment.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation free assessment.'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const Requesttrans = props => {
  const { intl } = props;
  //const fileList = project.files;

  return (
    <div className="preview page">
      <Helmet>
        <title>{intl.formatMessage(messages.htmlHeader)} - Shift</title>
      </Helmet>
      <Header
        title={intl.formatMessage(messages.headerTitle)}
        subtitle={intl.formatMessage(messages.headerSubTitle)}
        //steps={replaceID(steps, project.projectId)}
        steps={replaceID(steps, '003')}
        selectedStep={3}
        icon="preview"
        locale={props.locale}
      />
      <Alert
        title={intl.formatMessage(messages.htmlHeader)}
        message={print(props.status)}
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm>
            <div className="form">
              <label style={{ fontSize: '16px', textTransform: 'none' }}>
                I would like to:
              </label>

              <table>
                <tr>
                  <td style={{ width: '85%' }}>
                    <Checkbox
                      value="checkedC"
                      color="primary"
                      inputProps={{
                        'aria-label': 'secondary checkbox'
                      }}
                    />

                    <label style={{ display: 'inline', textTransform: 'none' }}>
                      Conduct a detailed assessment
                    </label>
                  </td>
                  <td>
                    <div
                      className="button-container"
                      style={{
                        display: 'inline',
                        alignContent: 'right'
                      }}
                    >
                      <button
                        className="button"
                        onClick={() => props.clickFAQHandler('1')}
                      >
                        <FormattedMessage
                          id="assessment.need.help.button.name"
                          defaultMessage="UpNeed Help ?"
                        />
                      </button>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <Checkbox
                      value="checkedC"
                      color="primary"
                      inputProps={{
                        'aria-label': 'secondary checkbox'
                      }}
                    />
                    <label style={{ display: 'inline', textTransform: 'none' }}>
                      Submit files for translation
                    </label>
                  </td>
                  <td />
                </tr>
              </table>
              <label>
                &nbsp;
                <br />
                <label style={{ display: 'inline', textTransform: 'none' }}>
                  Contact me at (enter at least 1 or both):
                </label>
                <br />
                &nbsp;
                <br />
              </label>

              <fieldset>
                <label style={{ display: 'inline', textTransform: 'none' }}>
                  <FormattedMessage
                    id="assessment.request.translation.Email.name"
                    defaultMessage="Email: "
                  />
                </label>
                {/* <label onClick={print(status)}>test</label> */}
                <Control.text model=".email" autoFocus style={{ width: 300 }} />
              </fieldset>

              <fieldset>
                <label style={{ display: 'inline', textTransform: 'none' }}>
                  <FormattedMessage
                    id="assessment.request.translation.Mobile.name"
                    defaultMessage="Mobile: "
                  />
                </label>
                {/* <label onClick={print(status)}>test</label> */}
                <Control.text
                  model=".projectName"
                  autoFocus
                  style={{ width: 300 }}
                />
              </fieldset>

              <label style={{ display: 'inline', textTransform: 'none' }}>
                I understand there is a charge for these service.
              </label>

              <p>&nbsp;</p>
              <div className="btn-toolbar" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  onClick={() => props.clickBackHandler()}
                >
                  <FormattedMessage
                    id="run-assessment.back.button.name"
                    defaultMessage="Back"
                  />
                </button>

                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  onClick={() => props.clickSubmitHandler()}
                >
                  <FormattedMessage
                    id="submit.button.name"
                    defaultMessage="Submit"
                  />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
    </div>
  );
};

Requesttrans.propTypes = {};

export default injectIntl(Requesttrans);



// WEBPACK FOOTER //
// ./src/components/views/Requesttrans/index.js